module.exports = __webpack_public_path__ + "img/sm.48eb2004.svg";